import type { ReactNode } from 'react';
import type { MetricProps } from './styled';
import { Title, Metric } from './styled';

type Size = 'small' | 'large' | 'largest';
interface Props extends MetricProps {
  title?: ReactNode;
  metric: ReactNode;
  size?: Size;
}

const getSizeProp = (size?: Size) => {
  switch (size) {
    case 'small':
      return { small: true };
    case 'large':
      return { large: true };
    case 'largest':
      return { largest: true };
    default:
      return {};
  }
};
export const DeprecatedKeyMetric = ({ title, metric, size }: Props) => {
  const key =
    title && typeof title === 'string'
      ? title.replace(/\s+/g, '-').toLowerCase()
      : '';
  const metricSize = getSizeProp(size);
  return (
    <>
      {size === 'small' && title && (
        <Title data-cy-id={`key-metric-title-${key}`} small={true}>
          {title}
        </Title>
      )}
      <Metric data-cy-id={`key-metric-value-${key}`} {...metricSize}>
        {metric}
      </Metric>
      {size !== 'small' && title && (
        <Title data-cy-id={`key-metric-title-${key}`}>{title}</Title>
      )}
    </>
  );
};
